export default {
  header: 'ניהול קרנות אלטרנטיביות',
  alternativeFunds: 'מספרי קרן אלטרנטיבית',
  number: 'מספר קרן אלטרנטיבית',
  addNewAlternativeFund: 'הוספת קרן אלטרנטיבית',
  accordType: 'עמלה',
  uid: 'מספר מזהה',
  company: 'חברה מנהלת',
  commission: 'עמלה %',
  branch: 'מוצר',
  addAlternativeFund: 'הוספת קרן אלטרנטיבית חדשה',
  alternativeFundType: 'סוג קרן אלטרנטיבית',
  alternativeFundName: 'שם קרן אלטרנטיבית',
  comments: 'הערות',
  deleteAlternativeFund: 'מחק קרן אלטרנטיבית',
  updataSuccess: 'קרן אלטרנטיבית עודכן בהצלחה',
  errorUpdating: 'שגיאה בעדכון קרן אלטרנטיבית',
  deleteSuccess: 'קרן אלטרנטיבית הועברה לארכיון בהצלחה',
  errorDeleting: 'שגיאה בהעברת קרן אלטרנטיבית לארכיון',
  verifyDeletion: 'האם אתה בטוח שברצונך למחוק את קרן אלטרנטיבית?',
  deletionReason: 'סיבת מחיקה',
};
